import React, { useEffect } from "react";
import { authToken } from "../lib/api";
import { ChevronLeft, ChevronRight, Download, FileText, X } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const evidenceUrl = (fileId) => `${BACKEND}/api/files/${encodeURIComponent(fileId)}/download?auth=${encodeURIComponent(authToken())}`;

export const EvidenceLightbox = ({ ev, zh, onClose, items, onNav }) => {
  const list = Array.isArray(items) && items.length > 1 ? items : null;
  const idx = list && ev ? list.findIndex((x) => x.fileId === ev.fileId) : -1;
  const go = (d) => { if (list && idx >= 0 && onNav) onNav(list[(idx + d + list.length) % list.length]); };
  useEffect(() => {
    if (!ev) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose && onClose();
      else if (list && e.key === "ArrowLeft") go(-1);
      else if (list && e.key === "ArrowRight") go(1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ev, idx, list]);
  if (!ev) return null;
  const isImg = (ev.contentType || "").startsWith("image");
  return (
    <div className="fixed inset-0 z-[80] bg-black/70 flex items-center justify-center p-4" onClick={onClose} data-testid="evidence-lightbox">
      <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-2.5 border-b border-slate-100">
          <p className="text-xs font-semibold text-slate-700 truncate">{ev.filename || (zh ? "凭证文件" : "Evidence")}{ev.by ? <span className="text-slate-400 font-normal ml-1.5">· {ev.by}</span> : null}</p>
          <div className="flex items-center gap-2 shrink-0">
            {list && <span data-testid="evidence-lightbox-counter" className="text-[11px] font-semibold text-slate-500 tabular-nums">{idx + 1} / {list.length}</span>}
            <a href={evidenceUrl(ev.fileId)} download={ev.filename || "evidence"} title={zh ? "下载" : "Download"}
              className="text-slate-400 hover:text-indigo-600" data-testid="evidence-lightbox-download"><Download className="h-4 w-4" /></a>
            <button onClick={onClose} className="text-slate-400 hover:text-slate-600" data-testid="evidence-lightbox-close"><X className="h-5 w-5" /></button>
          </div>
        </div>
        <div className="relative flex-1 overflow-auto bg-slate-900/95 flex items-center justify-center min-h-[280px]">
          {list && (
            <>
              <button data-testid="evidence-lightbox-prev" aria-label={zh ? "上一张" : "Previous"} onClick={() => go(-1)}
                className="absolute z-10 left-2 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white/15 hover:bg-white/30 text-white flex items-center justify-center transition-colors"><ChevronLeft className="h-6 w-6" /></button>
              <button data-testid="evidence-lightbox-next" aria-label={zh ? "下一张" : "Next"} onClick={() => go(1)}
                className="absolute z-10 right-2 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white/15 hover:bg-white/30 text-white flex items-center justify-center transition-colors"><ChevronRight className="h-6 w-6" /></button>
            </>
          )}
          {isImg ? (
            <img src={evidenceUrl(ev.fileId)} alt={ev.filename || "evidence"} className="max-w-full max-h-[72vh] object-contain select-none" data-testid="evidence-lightbox-img" />
          ) : (
            <div className="text-center text-slate-300 py-14 px-6" data-testid="evidence-lightbox-file">
              <FileText className="h-12 w-12 mx-auto mb-3 opacity-60" />
              <p className="text-sm break-all">{ev.filename || (zh ? "文件凭证" : "File")}</p>
              <a href={evidenceUrl(ev.fileId)} download={ev.filename || "evidence"}
                className="inline-block mt-3 text-xs font-semibold rounded-lg px-4 py-2 bg-indigo-600 text-white hover:bg-indigo-700">{zh ? "下载查看" : "Download"}</a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
